export interface SearchHistoryProduct {
  type: 'product';
  name: string;
  url: string;
  ID: string;
}

export interface SearchHistoryQuery {
  type: 'term';
  name: string;
}

export type SearchHistoryEntry = SearchHistoryQuery | SearchHistoryProduct;

const localStorageKey = 'search-history';
const maxItems = 10;

export const useSearchHistory = () => {
  const getItems = (): SearchHistoryEntry[] => {
    try {
      const json = window.localStorage.getItem(localStorageKey);
      if (json) {
        const data = JSON.parse(json);
        if (data) {
          return data;
        }
      }
    } catch (error: any) {
      if (APP_ENVIRONMENT !== 'PROD') {
        console.debug(error);
      }
    }
    return [];
  };

  const toMaxLength = (items: SearchHistoryEntry[]) => {
    while (items.length > maxItems) {
      items.pop();
    }
  };

  const setItems = (items?: SearchHistoryEntry[]) => {
    try {
      if (items?.length) {
        window.localStorage.setItem(localStorageKey, JSON.stringify(items));
      } else {
        window.localStorage.removeItem(localStorageKey);
      }
    } catch (error: any) {
      if (APP_ENVIRONMENT !== 'PROD') {
        console.debug(error);
      }
    }
  };

  const setSearchTerm = (name: string) => {
    if (!name.length) {
      return;
    }
    let items = getItems();
    items = items.filter((item) => !(item.type === 'term' && item.name === name));
    items.unshift({
      type: 'term',
      name,
    });
    toMaxLength(items);
    setItems(items);
  };

  const setSearchProduct = (name: string, url: string, ID: string) => {
    let items = getItems();
    items = items.filter((item) => !(item.type === 'product' && item.url === url));
    items.unshift({
      type: 'product',
      name,
      url,
      ID,
    });
    toMaxLength(items);
    setItems(items);
  };

  return {
    setSearchTerm,
    setSearchProduct,
    getItems,
    setItems,
  };
};
